<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
    <g fill="none" fill-rule="evenodd">
        <circle cx="11.163" cy="11.163" r="11.163" fill="#00A651"/>
        <path stroke="#FFF" stroke-linecap="square" stroke-width="1.541" d="M8.146 11.646l1.81 1.931 4.526-4.827"/>
    </g>
</svg>
